// TODO : 이 컴포넌트 포함하여 Form 컴포넌트는 추후 정리 필요
import * as React from 'react';
import {
  FormControl,
  TextField,
  Autocomplete,
} from '@mui/material';
import { Controller } from "react-hook-form";

const FormInputAutoComplete = ({ id="auto_complete", name, control, setValue, defaultValue, label, size = "small", options, onCustomChange, errorStyle, getOptionLabel, ...props }) => {
  // Autocomplete value는 ''가 아니라 null이어야 옵션(object)과 타입이 맞음 — 빈 문자열이면 첫 클릭 선택이 씹히는 경우가 있음
  const [selectValue, setSelectValue] = React.useState(defaultValue ?? null);
  const [inputValue, setInputValue] = React.useState('');
  const getOptionLabelRef = React.useRef(getOptionLabel);
  getOptionLabelRef.current = getOptionLabel;

  // defaultValue가 나중에 채워지면 선택값과 입력 문구를 맞춘다. undefined면 기존처럼 비워 둔다.
  React.useEffect(() => {
    if (defaultValue === undefined) return;
    const next = defaultValue ?? null;
    setSelectValue(next);
    if (next == null || next === '') {
      setInputValue('');
      return;
    }
    const labelFn = getOptionLabelRef.current;
    const text = typeof labelFn === 'function' ? labelFn(next) : (next.label ?? '');
    setInputValue(text == null ? '' : String(text));
  }, [defaultValue]);

  return (
    <FormControl size={size} fullWidth>
      <Controller
        name={name}
        control={control}
        render={({
          field: { onChange },
          fieldState: { error },
          formState,
        }) => (
          <Autocomplete
            value={selectValue}
            onChange={(event, newValue) => {
              onChange(newValue);
              setSelectValue(newValue);
              if (setValue && name) setValue(name, newValue);
              onCustomChange && onCustomChange(event, newValue);
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            id={id}
            options={options}
            {...props}
            {...(typeof getOptionLabel === 'function' ? { getOptionLabel } : {})}
            renderInput={
              (props) => {
                return <TextField
                  {...props}
                  label={label}
                  size={size}
                  helperText={errorStyle?.message && error ? error.message : null}
                  error={errorStyle?.border && !!error}
                />
              }
            }
          />
        )}
      />
    </FormControl>
  );
}

export default FormInputAutoComplete;
